import React from "react";
import { Link } from "react-router-dom";
import { imgUrl, buildSrcSet } from "../api";
import Price from "./Price";
import { useSiteConfig } from "../context/SiteConfigContext";

const ProductCard = ({ product }) => {
  const firstImg = (product.images && product.images[0]) || product.image;
  const { discount } = useSiteConfig();

  return (
    <Link to={`/product/${product.slug || product.id}`} className="group block" data-testid="product-card">
      <div className="relative aspect-[4/5] overflow-hidden bg-[var(--sand)]">
        <img
          src={imgUrl(firstImg)}
          srcSet={buildSrcSet(firstImg) || undefined}
          sizes="(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 50vw"
          alt={product.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        {discount?.active && (
          <span className="absolute top-3 left-3 bg-[var(--copper)] text-white text-[10px] tracking-[0.2em] uppercase px-2.5 py-1" data-testid="sale-badge">
            −{Math.round(discount.percent)}%
          </span>
        )}
      </div>
      <div className="pt-6 pb-2">
        <h3 className="font-serif-display font-light text-xl leading-tight text-[var(--espresso)] transition-colors group-hover:text-[var(--copper)]">
          {product.name}
        </h3>
        <Price price={product.price} className="block text-sm text-[var(--espresso)]/70 mt-1.5" />
      </div>
    </Link>
  );
};

export default ProductCard;
